import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { PageHeader, Loading, toastSuccessMessage } from "wup-module1-base";
import { PageTitleConstants, RoutePathConstants } from "../../Constants";
// import { QuestionnaireService } from "../../../Services";
import { Card } from "react-bootstrap";
import QuestionnaireForm from "./Form/QuestionnaireForm";

function QuestionnairenaireEdit() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [model, setModel] = useState({});
  const navigate = useNavigate();

  const onSubmit = (questionnaire) => {
    setIsSubmitting(true);
    // QuestionnaireService.update(id, question)
    //   .then((res) => {
    //     toastSuccessMessage(res.data);
    //   })
    //   .catch((error) => {
    //     toast.error(error.response.data.detail);
    //   })
    //   .finally(() => {
    //     setIsSubmitting(false);
    //   });
    const questionnaires = JSON.parse(sessionStorage.getItem("questionnaires"));
    const updatedQuestionnaires = questionnaires.map((item) =>
      item.id === id ? questionnaire : item
    );
    sessionStorage.setItem(
      "questionnaires",
      JSON.stringify(updatedQuestionnaires)
    );
    updateSessionStorages("pages", questionnaire.pages);
    updateSessionStorages("questions", questionnaire.questions);
    updateSessionStorages("answers", questionnaire.allAnswers);

    setIsSubmitting(false);
    toastSuccessMessage(`Pomyślnie edytowano ankietę ${questionnaire.name}`);
    navigate(`/${RoutePathConstants.Questionnaire}`);
  };

  const updateSessionStorages = (itemKey, toUpdate) => {
    const currentSession = JSON.parse(sessionStorage.getItem(itemKey));
    if (!!currentSession) {
      const toReplace = [...currentSession];
      toUpdate.forEach((elem) => {
        const existingElem = currentSession.find((i) => i.id === elem.id);
        if (!!existingElem) {
          let updateIdx = currentSession.indexOf(existingElem);
          toReplace[updateIdx] = elem;
        } else toReplace.push(elem);
      });
      sessionStorage.setItem(itemKey, JSON.stringify(toReplace));
    } else
      sessionStorage.setItem(
        itemKey,
        JSON.stringify(Array.isArray(toUpdate) ? toUpdate : [{ ...toUpdate }])
      );
    // console.log(currentSession);
    // if (!!currentSession)
    //   sessionStorage.setItem(
    //     itemKey,
    //     JSON.stringify([
    //       ...currentSession,
    //       toUpdate.isArray ? { ...toUpdate } : [...toUpdate],
    //     ])
    //   );
    // else
    //   sessionStorage.setItem(
    //     itemKey,
    //     JSON.stringify(toUpdate.isArray ? toUpdate : [{ ...toUpdate }])
    //   );
  };

  useEffect(() => {
    setIsLoading(true);
    // DO IMPLEMENTACJI
    // QuestionnaireService.getById(id)
    //   .then((res) => {
    //     const question = {
    //       ...res.data,
    //       relatedQuestionnaires: res.data.relatedQuestionnaires.sort((a, b) => a.order - b.order),
    //     };
    //     setModel(report);
    //   })
    //   .catch((error) => {
    //     toast.error(error.response.data.detail);
    //   })
    //   .finally(() => {
    //     setIsLoading(false);
    //   });

    const questionnaires = JSON.parse(sessionStorage.getItem("questionnaires"));
    if (!!questionnaires) {
      const questionnaire = questionnaires.find((i) => i.id === id);
      delete questionnaire.allAnswers;
      questionnaire.redirectNr = 1;
      setModel(questionnaire);
      setIsLoading(false);
    }
  }, [id]);

  return (
    <>
      <PageHeader content={PageTitleConstants.QuestionnaireEdit} />
      <Card>
        <Card.Body>
          {isLoading ? (
            <Loading />
          ) : (
            model && (
              <QuestionnaireForm
                onSubmit={onSubmit}
                model={model}
                isEdit={true}
                isSubmitting={isSubmitting}
              />
            )
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default QuestionnairenaireEdit;
